import type {VoiceDraftInput} from '../../protocol/voice-draft';
type Stage=(draft:VoiceDraftInput)=>Promise<void>;
let stage:Stage|null=null;
/** This action saves a work and opens host confirmation; it never generates audio itself. */
export function connectVoiceDraftStage(next:Stage){stage=next;return()=>{if(stage===next)stage=null;};}
export async function stageVoiceDraft(draft:VoiceDraftInput){
  const current=stage;if(!current)throw new Error('현재 와카 작업 연결을 확인한 뒤 다시 시도해 주세요.');
  await current(draft);
  if(current!==stage)throw new Error('작업 연결이 바뀌어 음성 요청을 중단했습니다.');
}
